import * as z from "zod/v4";

import { teamConversionDataSchema } from "./get-long-term-conversion-monitor";

export const getConversionTeamDetail = {
  name: "getConversionTeamDetail" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ team: teamConversionDataSchema.nullable() }),
};

export type GetConversionTeamDetailInput = z.infer<
  typeof getConversionTeamDetail.input
>;
export type GetConversionTeamDetailOutput = z.infer<
  typeof getConversionTeamDetail.output
>;
